export const meta = Object.freeze({
  id: "wiggle",
  label: "Freudiges Wackeln",
  duration: 1050,
  description: "Ein elastisches Links-rechts-Wackeln für Vorfreude und ungeduldige Momente.",
  tags: ["body", "reaction", "one-shot", "loopable"],
});

export async function run({ elements, animate }) {
  const body = animate(elements.actor, [
    { transform: "translateX(0) translateY(0) scale(1, 1) rotate(0deg)", offset: 0 },
    { transform: "translateX(-7px) translateY(1px) scale(1.035, .97) rotate(-4deg)", offset: .16 },
    { transform: "translateX(8px) translateY(-2px) scale(.985, 1.025) rotate(4.5deg)", offset: .34 },
    { transform: "translateX(-6px) translateY(0) scale(1.025, .98) rotate(-3.5deg)", offset: .52 },
    { transform: "translateX(5px) translateY(-1px) scale(.992, 1.015) rotate(2.6deg)", offset: .68 },
    { transform: "translateX(-2px) translateY(0) scale(1.008, .994) rotate(-1.2deg)", offset: .82 },
    { transform: "translateX(0) translateY(0) scale(1, 1) rotate(0deg)", offset: 1 },
  ], { duration: meta.duration, easing: "cubic-bezier(.45,0,.25,1)" });

  const shadow = animate(elements.shadow, [
    { transform: "translateX(0) scaleX(1)", opacity: .28, offset: 0 },
    { transform: "translateX(-4px) scaleX(1.06)", opacity: .30, offset: .16 },
    { transform: "translateX(5px) scaleX(.94)", opacity: .26, offset: .34 },
    { transform: "translateX(-3px) scaleX(1.04)", opacity: .30, offset: .52 },
    { transform: "translateX(3px) scaleX(.97)", opacity: .27, offset: .68 },
    { transform: "translateX(0) scaleX(1)", opacity: .28, offset: 1 },
  ], { duration: meta.duration, easing: "ease-in-out" });

  await Promise.allSettled([body.finished, shadow.finished]);
}
